import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, } from '@tanstack/react-router';
import { BookingWidget, } from '../../../../pages/bookingWidget/BookingWidget.js';
export const Route = createFileRoute('/appointment/widget/$userId/$customerId')({
    component: BookingWidgetWrapper,
});
function BookingWidgetWrapper() {
    const { userId } = Route.useParams();
    return _jsx(BookingWidget, { userId: userId });
}
//# sourceMappingURL=$userId.$customerId.js.map